import apiV2 from "api-v2";

interface QuoteRowRequest {
	inviteId: number;
	quoteId: number;
}

export interface SupplierRowCellPayload {
	column_id: number;
	value: string | null;
}

export interface SupplierRowData {
	id: number;
	created_by_type: "client" | "supplier";
	sort_order: number;
	unit_id: number | null;
	uuid: string | null;
}

interface CreateSupplierRowPayload {
	cells?: SupplierRowCellPayload[];
	unit_id: number | null;
}

interface UpdateSupplierRowPayload {
	cells?: SupplierRowCellPayload[];
	unit_id?: number | null;
}

export const getSupplierRows = async (
	request: QuoteRowRequest
): Promise<SupplierRowData[]> => {
	const response = await apiV2.get<{ data: SupplierRowData[] }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows`
	);
	return response.data.data;
};

export const createSupplierRow = async (
	request: QuoteRowRequest,
	payload: CreateSupplierRowPayload
): Promise<SupplierRowData> => {
	const response = await apiV2.post<{ data: SupplierRowData }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows`,
		payload
	);
	return response.data.data;
};

export const updateSupplierRow = async (
	request: QuoteRowRequest,
	rowId: number,
	payload: UpdateSupplierRowPayload
): Promise<SupplierRowData> => {
	const response = await apiV2.put<{ data: SupplierRowData }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows/${rowId}`,
		payload
	);
	return response.data.data;
};

export const deleteSupplierRow = async (
	request: QuoteRowRequest,
	rowId: number
): Promise<void> => {
	await apiV2.delete(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows/${rowId}`
	);
};

export interface BatchSaveRowPayload {
	id?: number | null;
	unit_id: number | null;
	sort_order?: number;
	cells?: SupplierRowCellPayload[];
}

export const batchSaveSupplierRows = async (
	request: QuoteRowRequest,
	rows: BatchSaveRowPayload[]
): Promise<SupplierRowData[]> => {
	const response = await apiV2.post<{ data: SupplierRowData[] }>(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows/batch-save`,
		{ rows }
	);
	return response.data.data;
};

export const batchDeleteSupplierRows = async (
	request: QuoteRowRequest,
	ids: number[]
): Promise<void> => {
	await apiV2.post(
		`rfx-invite/${request.inviteId}/quotes/${request.quoteId}/rows/batch-destroy`,
		{ ids }
	);
};
